import { render, staticRenderFns } from "./ShowMoreShowLessButton.vue?vue&type=template&id=6effa4f4&scoped=true&"
import script from "./ShowMoreShowLessButton.vue?vue&type=script&lang=js&"
export * from "./ShowMoreShowLessButton.vue?vue&type=script&lang=js&"
import style0 from "./ShowMoreShowLessButton.vue?vue&type=style&index=0&id=6effa4f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6effa4f4",
  null
  
)

export default component.exports